"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clientAuth = require("@devsta/client-auth");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TempAuthTokenHandler = /*#__PURE__*/function () {
  function TempAuthTokenHandler() {
    _classCallCheck(this, TempAuthTokenHandler);

    _defineProperty(this, "overrideCredentials", void 0);

    _defineProperty(this, "originalCredentials", void 0);

    this.overrideCredentials = false;
    this.originalCredentials = _clientAuth.credentials.get();
  }
  /**
   * Try to update credentials to temporary. Depending on the original we either use the
   * original user object or not
   *
   * @param {string} tempToken
   * @return {boolean}
   */


  _createClass(TempAuthTokenHandler, [{
    key: "attemptToOverrideToken",
    value: function attemptToOverrideToken(tempToken) {
      this.originalCredentials = _clientAuth.credentials.get();

      if (!tempToken || tempToken === this.originalCredentials.token) {
        return false;
      }

      this.overrideCredentials = true;

      if (!this.originalCredentials.auth) {
        _clientAuth.authLocalStore.save({
          token: tempToken,
          user: {},
          auth: true
        });

        return true;
      }

      var user = this.originalCredentials.user;

      _clientAuth.authLocalStore.save({
        token: tempToken,
        user: user,
        auth: true
      });

      return true;
    }
    /**
     * If the tempToken prop has been set we try to reset the credentials
     *
     *
     * @return {void}
     */

  }, {
    key: "attemptToResetToken",
    value: function attemptToResetToken() {
      if (!this.overrideCredentials) {
        return;
      }

      this.overrideCredentials = false;

      _clientAuth.authLocalStore.save(this.originalCredentials);
    }
  }]);

  return TempAuthTokenHandler;
}();

exports["default"] = TempAuthTokenHandler;